module.exports = __webpack_public_path__ + "img/car_00050.20f8f633.jpg";